module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportInfluencers.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadAll()
      }
    }
  }, [_vm._v("\n            Reload All\n            "), _c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.copyLink(null)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_vm._v("Copy Travel Form")]), _vm._v(" \n                "), _c('v-icon', _vm._g({
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "small": ""
          }
        }, on), [_vm._v("mdi-content-copy")])], 1)]
      }
    }]),
    model: {
      value: (_vm.linkCopied),
      callback: function($$v) {
        _vm.linkCopied = $$v
      },
      expression: "linkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "30px 0px 0px 0px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Email, Handle, Fullname",
      "hide-details": "auto",
      "id": "igHandle"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer Location"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.influencerGeos),
      callback: function($$v) {
        _vm.influencerGeos = $$v
      },
      expression: "influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.infCategories,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Categories"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeCategory(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.infCategory),
      callback: function($$v) {
        _vm.infCategory = $$v
      },
      expression: "infCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.joinedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.joinedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.joinedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Joined Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.paginate()
            }
          },
          model: {
            value: (_vm.joinedMonth),
            callback: function($$v) {
              _vm.joinedMonth = $$v
            },
            expression: "joinedMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.joinedMonth),
      callback: function($$v) {
        _vm.joinedMonth = $$v
      },
      expression: "joinedMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.joinedMonthOk
    }
  }, [_vm._v("\n              OK\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "platform-filter",
    attrs: {
      "role": "group",
      "aria-label": "Filter influencers by platform"
    }
  }, [_c('span', {
    staticClass: "platform-filter__label"
  }, [_vm._v("Platforms")]), _vm._v(" "), _vm._l((_vm.platformFilterOptions), function(platform) {
    return _c('v-btn', {
      key: platform.filterKey,
      staticClass: "platform-filter__button",
      class: {
        'platform-filter__button--active': _vm.searchFilter[platform.filterKey]
      },
      attrs: {
        "text": "",
        "small": "",
        "aria-pressed": String(_vm.searchFilter[platform.filterKey])
      },
      on: {
        "click": function($event) {
          return _vm.togglePlatformFilter(platform.filterKey)
        }
      }
    }, [(platform.imgIcon) ? _c('img', {
      staticClass: "platform-filter__logo",
      attrs: {
        "src": platform.imgIcon,
        "alt": ((platform.text) + " logo")
      }
    }) : _c('v-icon', {
      attrs: {
        "left": "",
        "size": "18",
        "color": platform.iconColor
      }
    }, [_vm._v("\n              " + _vm._s(platform.icon) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(platform.text))])], 1)
  })], 2)]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "200px",
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-checkbox', {
    staticClass: "pending-approval-checkbox mt-0",
    attrs: {
      "label": "Pending Approval",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.pendingApproval),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "pendingApproval", $$v)
      },
      expression: "searchFilter.pendingApproval"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewCompany",
      "data-toggle": "modal",
      "data-target": _vm.viewCompanyModalIdDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "ims-sticky-actions-table actions-column-visible elevation-1",
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.totalItems,
      "item-key": "_id"
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.profilePicture",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.profilePicture),
            "alt": "avatar"
          }
        })])], 1)])]
      }
    }, {
      key: "item.igHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.igHandle) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.igHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.igProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.igHandle
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#E4405F",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.igHandle))], 1)], 1) : _vm._e()])])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.tiktokHandle) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.tiktokHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.tiktokProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.tiktokHandle) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.tiktokHandle
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.tiktokHandle))]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: "item.youtubeHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.youtubeHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.youtubeProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.youtubeHandle) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/@' + item.youtubeHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.youtubeHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.fbHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.fbHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.fbProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.fbHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.facebook.com/' + item.fbHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#1877F2",
            "small": ""
          }
        }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.fbHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.xhsHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.xhsHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.xhsProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.xhsHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/xhs-black.png",
            "width": "18px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.xhsFullname))]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.linkedinHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.linkedinHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.linkedinProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.linkedinHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.linkedin.com/in/' + item.linkedinHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.linkedinHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.twitterHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.twitterHandle) ? _c('a', {
          attrs: {
            "href": 'https://x.com/' + item.twitterHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "15px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.twitterHandle))]) : _vm._e()])])]
      }
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.platform === 'tiktok') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.handle
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.handle))]) : (item.platform === 'youtube') ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + item.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.handle))], 1) : _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.handle
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle))], 1)])])]
      }
    }, {
      key: "item.joinedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(item.joinedAt)))])])]
      }
    }, {
      key: "item.lastLoginAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.lastLoginAt),
            expression: "item.lastLoginAt"
          }],
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(item.lastLoginAt)))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.totalFollowers))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.audienceCredibility) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(props.item.joinedAt)))])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [(_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.getInfluencerDataToView(item.id, item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Influencer")])])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action text--secondary",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getPlatformDataToView(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-group")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Assign Platform")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInfluencer(item.id)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticStyle: {
                  "color": "#fff"
                }
              }, on), [_vm._v("mdi-delete")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "right": "",
            "open-on-hover": false
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.copyLink(item)
                  }
                }
              }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                attrs: {
                  "bottom": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;

                    return [_c('v-icon', _vm._g({
                      staticStyle: {
                        "color": "#fff"
                      },
                      attrs: {
                        "small": ""
                      }
                    }, on), [_vm._v("mdi-content-copy")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('span', [_vm._v("Copy Travel Form")])])], 1)]
            }
          }], null, true),
          model: {
            value: (item.linkCopied),
            callback: function($$v) {
              _vm.$set(item, "linkCopied", $$v)
            },
            expression: "item.linkCopied"
          }
        }, [_vm._v(" "), _c('span', [_c('v-icon', {
          attrs: {
            "color": "white darken-2"
          }
        }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openResetDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticStyle: {
                  "color": "#fff"
                }
              }, on), [_vm._v("mdi-pencil-lock")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Reset Password")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.igHandle),
            expression: "item.igHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Instagram Audience")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.tiktokHandle),
            expression: "item.tiktokHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tik-tok-white.png",
                  "width": "20px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View TikTok Audience")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.youtubeHandle),
            expression: "item.youtubeHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Youtube Audience")])])], 1)], 1)])]
      }
    }], null, true)
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-reportlink"
    },
    domProps: {
      "value": _vm.reportLink
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('create-influencer-modal', {
    attrs: {
      "modalId": _vm.createModalId
    },
    on: {
      "createInfluencer": _vm.createInfluencer
    }
  }), _vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport,
      "handle": _vm.viewAudHandle,
      "platform": _vm.viewAudPlatform
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('view-influencer-company-modal', {
    attrs: {
      "modalId": _vm.viewCompanyModalId,
      "influencerData": _vm.viewInfluencerData_company
    }
  }), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "shortCodes": _vm.shortCodes
    }
  }), _vm._v(" "), _c('inf-platforms-view-modal', {
    attrs: {
      "platforms": _vm.viewPlatforms,
      "influencerID": _vm.selectedInfluencerID,
      "influencer": _vm.viewInfluencerData
    },
    on: {
      "reload": function($event) {
        return _vm.paginate(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.infPlatformsDialog),
      callback: function($$v) {
        _vm.infPlatformsDialog = $$v
      },
      expression: "infPlatformsDialog"
    }
  }), _vm._v(" "), _c('inf-reset-password-modal', {
    attrs: {
      "influencerID": _vm.selectedInfluencerID,
      "influencer": _vm.viewInfluencerData
    },
    on: {
      "reload": function($event) {
        return _vm.paginate(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.infPassResetDialog),
      callback: function($$v) {
        _vm.infPassResetDialog = $$v
      },
      expression: "infPassResetDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Exporting your data.\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6b3823"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/index.vue
// module id = 2031
// module chunks = 0